import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

interface DialogShowRegisterAlertProps {
  open: boolean;
  onClose: () => void;
  textAlert: string;
}

const DialogShowRegisterAlert: React.FC<DialogShowRegisterAlertProps> = (
  props
) => {
  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={{
        '& .MuiDialog-paper': {
          width: '400px',
          height: '150px',
          m: '0px',
        },
      }}
    >
      <DialogContent>
        <Typography>{props.textAlert}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogShowRegisterAlert;
